module.exports = __webpack_public_path__ + "img/advantages-2.c90f3d48.svg";